import Text from './text/index';
import Image from './image/index';
import Video from './video/index';
import Quote from './quote/index';
import Buttons from './buttons/index';
import List from './list/index';
import Highlights from './highlights/index';
import Rating from './rating/index';
import LatestVehicles from './latest-vehicles/index';
import USPs from './usps/index';
import Maps from './maps/index';
import Searchbox from './searchbox/index';
import Company from './company/index';
import Form from './form/index';
import Modal from './modal/index';
import Autochat from './autochat/index';
import Static from './static/index';
import Share from './share/index';
import SplitBlock from './split-block/index';
import Logos from './logos/index';

export default {
  StrapiPagebuilderPagebuilderBlocksText: Text,
  StrapiPagebuilderPagebuilderBlocksImage: Image,
  StrapiPagebuilderPagebuilderBlocksVideo: Video,
  StrapiPagebuilderPagebuilderBlocksQuote: Quote,
  StrapiPagebuilderPagebuilderBlocksButtons: Buttons,
  StrapiPagebuilderPagebuilderBlocksList: List,
  StrapiPagebuilderPagebuilderBlocksHighlights: Highlights,
  StrapiPagebuilderPagebuilderBlocksForm: Form,
  StrapiPagebuilderPagebuilderBlocksMaps: Maps,
  StrapiPagebuilderPagebuilderStaticLatestvehicles: LatestVehicles,
  StrapiPagebuilderPagebuilderStaticRating: Rating,
  StrapiPagebuilderPagebuilderStaticSearchbox: Searchbox,
  StrapiPagebuilderPagebuilderStaticUsps: USPs,
  StrapiPagebuilderPagebuilderStaticMaps: Maps,
  StrapiPagebuilderPagebuilderStaticCompany: Company,
  StrapiPagebuilderPagebuilderInteractionsModal: Modal,
  StrapiPagebuilderPagebuilderInteractionsAutochat: Autochat,
  StrapiPagebuilderPagebuilderStaticStatic: Static,
  StrapiPagebuilderPagebuilderStaticShare: Share,
  StrapiPagebuilderPagebuilderStaticSplitBlock: SplitBlock,
  StrapiPagebuilderPagebuilderStaticLogos: Logos,
};
